<template>
  <ark-div class='ark-leaderboard-content'>

    <ark-table v-if='leaderboardData[chosenPeriod].length' class='ark-leaderboard-table'>

      <ark-tr v-for='user in leaderboardData[chosenPeriod]' ark-test-id='leaderboard-user-row' class='ark-leaderboard-table__row' :key='user.userId'>

        <ark-td class='ark-leaderboard-table__cell ark-leaderboard-table__place'>{{user.rank}}</ark-td>

        <ark-td class='ark-leaderboard-table__cell ark-leaderboard-table__avatar'>
          <img v-if='user.avatarUrl' :src='user.avatarUrl'>
          <img src='http://ams.cdn.arkadiumhosted.com/assets/arena-4/arena/heap/no_avatar.jpg' v-else>
        </ark-td>

        <ark-td class='ark-leaderboard-table__cell ark-leaderboard-table__name'>{{user.userName | name}}</ark-td>

        <ark-td class='ark-leaderboard-table__cell ark-leaderboard-table__score'>{{user.value}}</ark-td>
      </ark-tr>
    </ark-table>

    <ark-div class="ark-leaderboard-info-text" v-else>{{emptyLeaderboardText}}</ark-div>
  </ark-div>
</template>

<script>
  export default {
    props: ['leaderboardData', 'chosenPeriod', 'emptyLeaderboardText'],
    filters: {
      name: function (value) {
        if (!value) return ''
        value = value.toString()
        let firstName
        let lastName
        try {
          firstName = value.split(' ')[0]
          lastName = value.split(' ')[1].charAt(0)
        } catch (error) {
          return value
        }
        return `${firstName} ${lastName}`
      }
    }
  }
</script>

<style lang="scss" src="./LeaderboardContent.scss"></style>



// WEBPACK FOOTER //
// LeaderboardContent.vue?2a6c0270